<template>
    <div class="sms-area">
        <div v-if="isSmsSent">{{ $t('sms sent') | capitalize }}</div>
        <div v-else>
            {{ $t('You didn\'t receive the SMS') }}?
            <span
                @click="$emit('sendSms')"
                class="action-text"
            >
                {{ $t('resend SMS') | capitalize }}
            </span> {{ $t('or') }}
            <span
                @click="$emit('changePhone')"
                class="action-text"
            >
                {{ $t('change phone') }}
            </span>
            {{ $t('if it is not correct') }}.
            {{ $t('If you encounter other problems, we are here to')}}
            <span
                class="action-text"
                @click="$emit('helpClick')"
            >
                {{ $t('help') | capitalize }}
            </span>
        </div>
        <div v-if="smsSendError">{{ $t(smsSendError) | capitalize }}</div>
    </div>
</template>

<script>
    export default {
        name: 'SendSms',
        props: {
            isSmsSent: {
                type: Boolean,
                required: true,
            },
            smsSendError: {
                type: String,
                required: true,
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/userProfile/smsValidation/components/SendSms.vue